import useScreenName from "../../hooks/useScreenName";
import useQueryParams from "../../hooks/useQueryParams";
import {
  UNDERWRITING_UI_EMBED_PAGES,
  UNDERWRITING_UI_ROUTE_PATHS,
} from "./underwritingUi.constants";
import UnderwritingUiFrame from "./UnderwritingUiFrame";
import UnderwritingUiPageShell from "./UnderwritingUiPageShell";
import useUnderwritingUiEmbedUrl from "./useUnderwritingUiEmbedUrl";

type QueryParams = {
  base: string;
  target: string;
};

export default function PolicyCompareEmbedPage() {
  useScreenName("Underwriting UI");
  const [{ base, target }] = useQueryParams<QueryParams>({
    base: "",
    target: "",
  });
  const { embedUrl, isLoading, error } = useUnderwritingUiEmbedUrl(
    base && target
      ? {
          page: UNDERWRITING_UI_EMBED_PAGES.POLICY_COMPARE,
          basePolicyName: String(base),
          targetPolicyName: String(target),
        }
      : null,
    "Compare link is incomplete. Select two policies and try again."
  );

  return (
    <UnderwritingUiPageShell
      title="Policy compare"
      subtitle={base && target ? `${base} → ${target}` : undefined}
      backTo={UNDERWRITING_UI_ROUTE_PATHS.POLICIES}
      backLabel="Policies"
    >
      <UnderwritingUiFrame
        title={`Policy compare ${base} vs ${target}`}
        embedUrl={embedUrl}
        isLoading={isLoading}
        error={error}
        loadingText="Loading compare view..."
      />
    </UnderwritingUiPageShell>
  );
}
